<template>
    <div>
        <section v-if="!result">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-12 text-center" v-if="loading">
                        <img src="/images/loading.svg" width="50" alt="Loading">
                    </div>
                    <div class="col-md-12" v-else>
                        Vehicle not found.
                    </div>
                </div>
            </div>
        </section>
        <section id="single-vehicle-page" v-else>
            <div class="container-fluid grey container-fluid-wide">
                <div class="row">
                    <div class="col-md-12">
                        <div class="container-fluid">
                            <div class="next-prev" v-if="currentNextPrev">
                                <a class="prev" href="#!" @click.prevent="handleVehicleNextPrev(false)">Prev</a>
                                <span>{{ vehicleNextPrevCounterText }}</span>
                                <a class="next" href="#!" @click.prevent="handleVehicleNextPrev(true)">Next</a>
                            </div>
                        </div>
                        <div id="bid-now">
                            <div class="left">
                                <div class="model-title">
                                    {{ result.year }}
                                    {{ result.make }}
                                    {{ result.model }}
                                </div>
                                <div v-if="$userCan('fav_list')" class="favourite" @click="favListModalOpen = true">
                                    <span>Add to list</span>
                                </div>
                                <a v-if="currentNextPrev && currentNextPrev.back_to_all" :href="currentNextPrev.back_to_all" class="link back">
                                    Back to all
                                </a>
                            </div>
                            <template v-if="showBidBox">
                                <div class="current-bid">
                                    <div id="bid-notes">
                                        <div class="row">
                                            <div class="col-11">
                                                <div class="form-group">
                                                    <label for="bid-notes">
                                                        Bid Notes
                                                        <span @click.prevent="addToBidNote('&#x1F6AD')"
                                                              class="cursor-pointer">&#x1F6AD</span>
                                                    </label>
                                                    <input type="text" id="bidNote" name="bidNote"
                                                           placeholder="Bid Notes"
                                                           value="" v-model="bidNote">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="place-bid">
                                    <div class="item-place-bid">
                                        <div class="title-place-bid">
                                            Estimated Landed Cost
                                        </div>
                                        <div class="form-group inline-label">
                                            <label for="estimatedLandedCost">
                                                Bid
                                                {{user_currency_code}}
                                                {{user_currency_sign}}
                                            </label>
                                            <input type="text" id="estimatedLandedCost" name="estimatedLandedCost"
                                                   value=""
                                                   ref="bidNzd"
                                                   v-model="estimatedLandedCost" :disabled="userHasBid"
                                                   @input="onLandedCostInput" @keyup.enter="onBidClick">
                                        </div>
                                    </div>
                                    <div class="item-place-bid">
                                        <div class="title-place-bid">
                                            Bid (thousands of yen)
                                        </div>
                                        <div class="form-group inline-label float-span">
                                            <label for="bidPrice">Bid JPY ¥</label>
                                            <input type="text" id="bidPrice" name="bidPrice" value=""
                                                   ref="bidJpy"
                                                   v-model="bidPriceProxy" @input="onBidPriceInput"
                                                   @keyup.enter="onBidClick" :disabled="userHasBid">
                                            <span class="no-click">,000</span>
                                        </div>
                                    </div>
                                    <div class="item-place-bid suggested-range">
                                        <div class="title-place-bid">
                                            <span v-if="$userIsAdmin() && result.market_research && result.market_research.length">
                                                Suggested bid: <br />{{suggestedRange}}
                                            </span>
                                        </div>
                                        <button id="bid-button" class="btn" @click="onBidClick">
                                            <template v-if="userHasBid">
                                                Change Bid
                                            </template>
                                            <template v-else>
                                                Place Bid :-)
                                            </template>
                                        </button>
                                        <b-tooltip ref="bidResultTooltip" :disabled.sync="bidTooltipDisabled"
                                                   target="bid-button" triggers="manual">
                                            {{ bidResult }}
                                        </b-tooltip>
                                        <div class="pop-up-bid">
                                            <strong>Warning :</strong> Lorem ipsum dolor sit amet, consectetur
                                            adipiscing
                                            elit. Vestibulum at odio vel erat semper pretium.
                                            <button class="close-pop-up-bid"></button>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                        <div id="bid-history">
                            <div class="table-responsive">
                                <table class="bid-history table">
                                    <thead>
                                    <tr>
                                        <th>(+/-)</th>
                                        <th>Day</th>
                                        <th>Auc/Lot</th>
                                        <th>ID</th>
                                        <th>Make</th>
                                        <th>Model/Grade</th>
                                        <th>Chassis</th>
                                        <th v-if="$userIsAdmin()">CO2 (indication only)</th>
                                        <th>Year</th>
                                        <th>Kms</th>
                                        <th>Colour</th>
                                        <th>CC</th>
                                        <th>Trans</th>
                                        <th>F</th>
                                        <th>Cnd</th>
                                        <th></th>
                                        <th>Start</th>
                                        <th>Result</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr @contextmenu.prevent="openFavList">
                                        <td class="tag">
                                            <input type="checkbox" id="tag" name="checkbox-tag" v-model="isFavourite"
                                                   @change="toggleFavourite"/>
                                            <label for="tag"></label>
                                            <small>Tag</small>
                                        </td>
                                        <td class="date">
                                            {{ getDate(result.auction_date) }}
                                        </td>
                                        <td class="yellow">
                                            <div>{{ result.auction_house }}</div>
                                            <div>{{ result.lot }}</div>
                                        </td>
                                        <td class="id-bid">
                                            {{ result.api_id }}
                                        </td>
                                        <td class="make">
                                            {{ result.make }}
                                        </td>
                                        <td class="model">
                                            {{ result.model }} /
                                            <template v-if="translatedFields['grade']">
                                                <span v-html="translatedFields['grade']"></span>
                                            </template>
                                            <template v-else>
                                                <span v-html="result.grade"></span>
                                            </template>
                                        </td>
                                        <td>
                                            {{ result.chassis }}
                                        </td>
                                        <td v-if="$userIsAdmin()">
                                            <div v-if="result.co2_text" :class="result.co2_text[0] === '-' ? 'text-danger' : 'text-success'">
                                                {{ result.co2_text.replace('-', '') }}
                                            </div>
                                        </td>
                                        <td>
                                            {{ result.year }}
                                        </td>
                                        <td>
                                            {{ numberWithCommas(result.mileage) }}
                                        </td>
                                        <td class="color">
                                            {{ result.color }}
                                        </td>
                                        <td>
                                            {{ result.engine_capacity }}
                                        </td>
                                        <td>
                                            {{ result.transmission }}
                                        </td>
                                        <td>
                                            {{ result.fuel_type }}
                                        </td>
                                        <td>
                                            {{ result.condition }}
                                        </td>
                                        <td>
                                            {{ result.equipment }}
                                        </td>
                                        <td class="blue">
                                            {{ result.currency_sign }} {{ numberWithCommas(result.start_price / 1000) }}
                                            k
                                        </td>
                                        <td v-if="!is_mobile" :class="isSold() && !finalSoldPrice() ? 'sold' : ''">
                                            <small :title="getJapanDiff(result.auction_date)">
                                                <template v-if="'00:00' === getTime(result.auction_date, 'HH:mm')">
                                                    Start time unknown
                                                </template>
                                                <template v-else>
                                                    {{ getTime(result.auction_date, 'h:mma') }} JPN /
                                                    {{ getNZDateTime(result.auction_date).format('h:mma') }} NZ
                                                </template>
                                            </small>
                                            <div v-if="isSold()">
                                                <span v-if="result.bid_status === 'negotiation'">Negotiation</span>
                                                <span v-else-if="result.bid_status === 'cancelled'">Cancelled</span>
                                                <span v-else-if="result.bid_status === 'sold'">Sold</span>
                                                <span v-else-if="result.bid_status === 'processing'"></span>
                                                <span v-else-if="result.bid_status === 'sold to sbl'">
                                                        <template v-if="$userIsAdmin()">Sold to SBL</template>
                                                        <template v-else>Sold</template>
                                                </span>
                                                <span v-else>Not sold</span>
                                                <template v-if="result.end_price && result.end_price > 0">
                                                    <br/>
                                                    <span :title="numberWithCommas(result.end_price) + ' yen'"
                                                          class="blue">
                                                        ¥ {{ numberWithCommas(result.end_price / 1000) }} k
                                                    </span>
                                                </template>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-if="is_mobile">
                                        <td colspan="14" :class="isSold() && !finalSoldPrice() ? 'sold' : ''">
                                            <small :title="getJapanDiff(result.auction_date)">
                                                <template v-if="'00:00' === getTime(result.auction_date, 'HH:mm')">
                                                    Start time unknown
                                                </template>
                                                <template v-else>
                                                    {{ getTime(result.auction_date, 'h:mma') }} JPN /
                                                    {{ getNZDateTime(result.auction_date).format('h:mma') }} NZ
                                                </template>
                                            </small>
                                            <div v-if="isSold()">
                                                <span v-if="result.bid_status === 'negotiation'">Negotiation</span>
                                                <span v-else-if="result.bid_status === 'cancelled'">Cancelled</span>
                                                <span v-else-if="result.bid_status === 'sold'">Sold</span>
                                                <span v-else-if="result.bid_status === 'processing'"></span>
                                                <span v-else-if="result.bid_status === 'sold to sbl'">
                                                    <template v-if="$userIsAdmin()">Sold to SBL</template>
                                                    <template v-else>Sold</template>
                                                </span>
                                                <span v-else>Not sold</span>
                                                <template v-if="result.end_price && result.end_price > 0">
                                                    <br/>
                                                    <span :title="numberWithCommas(result.end_price) + ' yen'"
                                                          class="blue">
                                                        ¥ {{ numberWithCommas(result.end_price / 1000) }} k
                                                    </span>
                                                </template>
                                            </div>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="all-bid">
                                <VehicleMessages :vehicle="result" />
                                <template v-if="result.userBids && result.userBids.length">
                                    <div v-for="(bid,index) in result.userBids">
                                        <!--<div class="bid" v-for="latestBid in result.userBids">-->
                                        <div class="bid" v-if="'bid_price_landed' in bid">
                                            <div class="arrow item">
                                                <button type="button" class="collapsed" data-toggle="collapse"
                                                        :data-target="'#bid-messages-' + bid.id"
                                                        aria-expanded="index === 0 ? 'true' : 'false'"
                                                        :aria-controls="'#bid-messages-' + bid.id">
                                                    <img src="../../images/collapse.svg" alt="Collapse">
                                                </button>
                                            </div>
                                            <template v-if="is_mobile">
                                                <div class="date item">
                                                    {{ getDate(bid.created_at) }} {{ getTime(bid.created_at) }}
                                                </div>
                                            </template>
                                            <template v-else>
                                                <div class="date item">
                                                    {{ getDate(bid.created_at) }}
                                                </div>
                                                <div class="hour item">
                                                    {{ getTime(bid.created_at) }}
                                                </div>
                                            </template>
                                            <div class="note item">
                                                <strong>{{ bid.note }}</strong>
                                                [SystemNote:
                                                <template>{{ bid.bid_by_name }};</template>
                                                <template>landed={{bid.currency_sign}}{{ numberWithCommas(bid.bid_price_landed)}};</template>
                                                FX={{bid.exchange_rate }}]
                                            </div>
                                            <div class="item bid-details-container" :style="bidColourStyle(bid)">
                                                <div class="who">
                                                    <template v-if="bid.user">
                                                        <a :href="$laravelRoute('users.show', bid.user.id)"
                                                           class="person">{{ bid.user.name }}</a>
                                                        <span v-if="bid.user.company">{{ bid.user.company.name }}</span>
                                                    </template>
                                                    <span class="bump" v-if="$userIsAdmin()">{{ bumpBidDisplay(bid.bump_bid) }}</span>
                                                </div>
                                                <div class="bid-placed" v-if="bid.bid_price_jpy">
                                                    <div :class="bid.bump_bid && $userIsAdmin() ? 'strikeout' : ''">
                                                        ¥ {{ numberWithCommas(bid.bid_price_jpy) }}
                                                    </div>
                                                    <div v-if="bid.bump_bid && $userIsAdmin()" class="bid-total">
                                                        Cost ¥ {{ numberWithCommas(bid.bid_price_jpy + bid.bump_bid) }}
                                                    </div>
                                                </div>
                                                <div class="tag">
                                                    <input type="checkbox" :id="`bidtag-${bid.id}`"
                                                           @change="onBidFavChange(bid.id)" :value="true"
                                                           v-model="bidFavourites[bid.id]"/>
                                                    <label :for="`bidtag-${bid.id}`"></label>
                                                </div>
                                                <div v-if="bid.remark" class="remark">
                                                    <strong>Remark</strong>
                                                    {{bid.remark}}
                                                </div>
                                                <div v-if="showStatus(bid)" :class="['bid-status', 'bid-status-'+bid.status_id]">
                                                    <strong>Status</strong>
                                                    <span v-if="bid.status_id === 2">
                                                        Retry:
                                                        {{bid.retry_count}} time<template v-if="bid.retry_count > 1 || bid.retry_count === 0">s</template>
                                                        <span v-if="bid.last_retried_at" :title="'Last retry at ' + getTime(bid.last_retried_at)">
                                                            | {{getTimeAgo(bid.last_retried_at)}}
                                                        </span>
                                                        {{nextRetryTime}}
                                                        
                                                    </span>
                                                    <span v-else-if="bid.status_id === 3" title="The bid failed, the vehicle is likely unavailable in Nichibo.">
                                                        Failed - last retry at {{getTime(bid.last_retried_at)}}
                                                    </span>
                                                    <span v-else-if="bid.status_id === 4" title="The bid will be sent to Nichibo on auction day">Queued</span>
                                                    <span v-else-if="bid.status_id === 5 && $userIsSuperAdmin()" title="This bid is on hold due to another bid beating it">Hold</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="bid bid-note-only" v-else-if="bid.raw_note && bid.raw_note.length">
                                            <div class="note item">Bidder question: {{bid.raw_note}}</div>
                                        </div>
                                        <div :id="'bid-messages-' + bid.id" class="collapse show" v-if="bid.messages">
                                            <template v-for="msg in bid.messages">
                                                <div class="bid history-bid" :class="messageClass(msg, bid)"
                                                     @click="selectMessage(msg)">
                                                    <div class="date item">
                                                        {{ getDate(msg.created_at) }}
                                                    </div>
                                                    <div class="hour item">
                                                        {{ getTime(msg.created_at) }}
                                                    </div>
                                                    <div class="message-by item">
                                                        {{ msg.firstname }} {{ msg.lastname }}
                                                    </div>
                                                    <div class="note item">
                                                        <span>
                                                            <strong v-if="msg.rep_only">staff: </strong>
                                                            {{ msg.message }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </template>
                                        </div>
                                        <div class="history-buttons" v-if="'bid_price_landed' in bid">
                                            <a v-if="$userIsAdmin()" class="link" @click="openTopBidModal(bid)">
                                                Top Bid
                                            </a>
                                            <a class="link add-message" @click="openMessageModal(bid)">
                                                <template v-if="$userIsAdmin()"> Client Message </template>
                                                <template v-else>Add Message</template>
                                            </a>
                                            <a v-if="$userIsAdmin() && result.is_moto" class="link add-message" @click="openStaffMessageModal(bid)">
                                                Moto Message
                                            </a>

                                            <template v-if="$userIsAdmin()">
                                                <a v-if="bid.bid_price_jpy" class="link staff-message text-success"
                                                   @click="addBidMessage(bid.id, keepBidMsg, true   )">
                                                    Keep Bid
                                                </a>
                                            </template>
                                            <template v-if="'bid_price_landed' in bid">
                                                <a v-if="$userIsAdmin() || bid.user_id === loggedInUser.id" class="link staff-message" :disabled="!$canChangeBid(bid, result)"
                                                   @click="openChangeBidModal(bid)">
                                                    Change bid
                                                </a>
                                            </template>
                                            <template v-if="$userIsAdmin()">
                                                <a v-if="bid.bid_price_jpy" class="link staff-message text-danger"
                                                   @click="cancelBid(bid.id)">
                                                    Cancel bid
                                                </a>
                                            </template>
                                            <template v-if="$userIsAdmin()">
                                                <a class="link copy-stock float-right" @click="copyVehicleToStock(result.api_id)" :class="copiedToStock ? 'disabled' : ''">
                                                    Copy to dealer stock
                                                </a>
                                                <template v-if="result.message_images">
                                                    <template v-if="bid.can_view_nichibo_images">
                                                        <el-tooltip placement="top" content="They already have access to the images, to send the email again you can click this button">
                                                            <a class="link disabled  float-right" @click="onClickSendNichiboImages(bid)">
                                                                Send Nichibo Images <icon icon="fa-picture-o" :loading="loadingSendNichiboImages"></icon>
                                                            </a>
                                                        </el-tooltip>
                                                    </template>
                                                    <template v-else>
                                                        <a class="link  float-right" @click="onClickSendNichiboImages(bid)">
                                                            Send Nichibo Images <icon icon="fa-picture-o" :loading="loadingSendNichiboImages"></icon>
                                                        </a>
                                                    </template>
                                                </template>
                                                <span class="float-right"> | &nbsp; &nbsp; &nbsp;</span>
                                                <div class="bids-icons-container">
                                                    <span class="col-sm-12 px-0 py-2 py-sm-0 d-block d-sm-inline">
                                                        <span @click="addBidMessage(bid.id, '&#x1F6AD', true)"
                                                              class="cursor-pointer">&#x1F6AD</span>
                                                    </span>
                                                </div>
                                            </template>
                                        </div>

                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-12">
                        <div id="description-vehicle">

                            <div class="description-vehicle">
                                <p>
                                    <template v-if="result.ac || result.equipment">
                                        <strong>Equipment:</strong> {{ result.ac }} {{ result.equipment }}
                                    </template>
                                </p>
                                <template v-if="$userIsAdmin() && result.userBids && result.userBids.length && result.userBids[0].buyers_at_auction && getSiteSetting('nichibo_sales_contacts')">
                                    <strong>Buyers at auction </strong>
                                    <template v-for="buyer in result.userBids[0].buyers_at_auction.split(',')">
                                        <br />{{buyer}}
                                        <template v-for="contact in getSiteSetting('nichibo_sales_contacts').contacts">
                                            <a v-if="contact.name === buyer" :href="'tel:'+contact.number.replaceAll(' ', '')"> tel: {{contact.number}}</a>
                                        </template>
                                    </template>
                                </template>
                                <template v-if="translatedFields['description']">
                                    <span class="translated" v-html="translatedFields['description']"></span>
                                </template>
                                <template v-else>
                                    <span class="not-translated" v-html="result.description"></span>
                                </template>
                            </div>
                            <div id="tabs-images" class="info-tabs">
                                <div class="tab-content">
                                    <div role="tabpanel" id="images" class="tab-pane fade-in active">
                                        <div id="vehicle-image" v-if="result.images">
                                            <VehicleImages :images="result.images" :extra="result.images.extra"/>
                                        </div>
                                    </div>
                                    <div role="tabpanel" id="avto-images" class="tab-pane fade">
                                        <div id="avto-vehicle-image" v-if="avtoImages">
                                            <div class="container-image">
                                                <template v-for="type in imagesType">
                                                    <a v-if="avtoImages[type]"
                                                       class="three set-height"
                                                       :href="avtoImages[type]['medium']"
                                                       data-fancybox="gallery"
                                                    >
                                                        <div class="magnifier"></div>
                                                        <img :src="avtoImages[type]['medium']"
                                                             :alt="result.model + result.make + type">
                                                    </a>
                                                </template>
                                                <div class="two container-thumbnail"
                                                     v-if="avtoImages.extra && avtoImages.extra.length">
                                                    <a class="six set-height" :href="image['large']"
                                                       data-fancybox="gallery" v-for="(image, i) in avtoImages.extra">
                                                        <div class="magnifier"></div>
                                                        <img :src="image['medium']"
                                                             :alt="result.model + result.make + i">
                                                    </a>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <ul class="nav nav-tabs" role="tablist">
                                    <li class=" active"><a data-toggle="tab" href="#images" role="tab">Primary
                                        images({{ imagesCount }})</a>
                                    </li>
                                    <li class=""><a data-toggle="tab" href="#avto-images" role="tab">Secondary
                                        images({{ avtoImagesCount }})</a></li>
                                </ul>
                            </div>
                            <div id="action-buttons" class="single-vehicle">
                                <!-- <send-email vehicle_id= '{{ result.api_id }}'></send-email> -->
                                <template v-if="$userIsAdmin()">
                                    <a @click="emailModalOpen = true" class="btn">Send Email</a>
                                    <a @click="recommendModalOpen = true" class="btn">Send Recommend</a>
                                    <a :href="$laravelRoute('history.get', {vid: result.api_id})" target="_blank"
                                       class="btn">View Activity</a>
                                    <button class="btn" @click="copyVehicleToStock(result.api_id)" :disabled="copiedToStock">
                                        Copy to dealer stock
                                    </button>
                                    <a :href="$laravelRoute('vehicle-csv', [result.api_id])" target="_blank"
                                       class="btn">Spreadsheet</a>
                                </template>
                                <a :href="$laravelRoute('vehicle-pdf', [result.api_id])" target="_blank" class="btn">Print</a>
                                <a v-if="$userCan('fav_list')" href="#" @click="showFavouriteTags" class="btn">Add to
                                    list</a>
                            </div>
                            <div id="tabs-vehicle" class="info-tabs info-single-vehicle">
                                <ul class="nav nav-tabs" role="tablist">
                                    <template v-if="result.market_research && result.market_research.length">
                                        <li>
                                            <a data-toggle="tab" class="active" href="#market-research-tab" role="tab">Market Research</a>
                                        </li>
                                        <li class="">
                                            <a data-toggle="tab" class="" href="#exclusion" role="tab">Claim Exclusions</a>
                                        </li>
                                    </template>
                                    <template v-else>
                                        <li>
                                            <a data-toggle="tab" class="active" href="#exclusion" role="tab">Claim Exclusions</a>
                                        </li>
                                    </template>
                                    <li v-if="result.co2_emissions && $userIsAdmin()">
                                        <a data-toggle="tab" href="#emissions" role="tab">Emissions</a>
                                    </li>
                                    <li>
                                        <a data-toggle="tab" href="#inspection" role="tab">Inspection Codes</a>
                                    </li>
                                    <li>
                                        <a data-toggle="tab" class="" href="#terms" role="tab">Terms & Conditions</a>
                                    </li>
                                </ul>

                                <div class="tab-content">
                                    <div role="tabpanel" id="exclusion" class="tab-pane " :class="result.market_research && result.market_research.length ? '' : 'fade-in active show'">
                                        <h2>Claims Exclusions info</h2>
                                        <h3>SBL will not accept any claims:</h3>
                                        <ul>
                                            <li>for vehicles 10 years of age and over.</li>
                                            <li>for vehicles which have travelled 100,000km or over.</li>
                                            <li>for vehicles which have an auction grade below 4.0.</li>
                                            <li>for issues notified to you at time of purchase.</li>
                                            <li>after a vehicle has been retailed or registered.</li>
                                            <li>for issues with a value of less than $600 + GST.</li>
                                            <li>successive claims for any vehicle.</li>
                                            <li>for any type of transmission issues in any make or model of vehicle.</li>
                                            <li>for electrical and mechanical issues on all high performance vehicles ie Audi S3/S4/RS3/RS4/S5/RS5/S6/RS6/RS7/S8 BMW M3/M5/All 7 series, all Mercedes 63 variants, all Porsche variants, Jaguar F Types, and all Jaguar 5.0l petrol variants.</li>
                                            <li>for any issues on BMW I3 or Smart Fourtwo or BMW 535i Active Hybrid.</li>
                                            <li>for any issues relating to EV or Hybrid batteries for any make or model.</li>
                                            <li>for air conditioning faults or failure in any make or model of vehicle.</li>
                                            <li>for any stereo, infotainment or navigation faults or failure in any make or model of vehicle.</li>
                                            <li>relating to spare keys missing mats or tono covers.</li>
                                            <li>for airbag or air suspension or electric shocks in any make or model variant.</li>
                                            <li>for Mazda product in Diesel in all make and model variants sub 2015.</li>
                                            <li>for electrical or mechanical faults in Mini variants sub 2015.</li>
                                            <li>for electrical or mechanical faults in Volvo V40/V60 sub 2015.</li>
                                            <li>for all VW and Audi product sub-2013 or pre facelift.</li>
                                            <li>for costs not directly relating to a claim (eg reconditioning or servicing).</li>
                                            <li>for any costs associated with "No TDN number" on export certificate.</li>
                                            <li>for modified vehicles.</li>
                                            <li>for warning lights on following a clear Astral Inspection.</li>
                                            <li>for rust in any way, shape or form for Land Rover, and Range Rover vehicles</li>
                                            <li>
                                                for known Manufacturers issues and faults as described below:
                                                <ul>
                                                    <li>Toyota – seatbelts or Mark X shocks.</li>
                                                    <li>Nissan – Presage inner wheel arch rust – X-trail rust in rear suspension tower – March/Tida/Note rust in fire wall.</li>
                                                    <li>Mazda – MPV chassis rails – Demio rust around rear suspension – I Stop in any model – RX8 engine – 2.3 Turbo engines CX7/MPV/Axela and Atenza – CX5 Diesel KE2FW/KE2AW</li>
                                                    <li>Subaru – Forester seatbelts – Legacy Engine.</li>
                                                    <li>BMW – electronics – I Drive leaking oil – tappet noise.</li>
                                                    <li>Audi – A8 electrical or mechanical issues.</li>
                                                </ul>
                                            </li>
                                        </ul>
                                        <a href="/files/SBL_Claims_Policy_October_2022.pdf"
                                           target="_blank">View the full SBL claims policy here</a>
                                    </div>
                                    <div role="tabpanel" id="inspection" class="tab-pane fade">
                                        <h2>Inspection code info</h2>
                                        <h3>Inspection Sheet Codes</h3>
                                        <p>The numbers 1,2,3 are used to qualify flaws and damage as approximately
                                            minor, medium, or serious.</p>
                                        <p>The following letters represent the type of flaw or damage.</p>
                                        <p class="inline-flex"><span>A</span> <span>Scratch marks</span></p>
                                        <p class="inline-flex"><span>B</span> <span>Bend/distortion or dent</span></p>
                                        <p class="inline-flex"><span>BP</span> <span>Panel repair</span></p>
                                        <p class="inline-flex"><span>C</span> <span>Corrosion or rust</span></p>
                                        <p class="inline-flex"><span>E</span> <span>Dimples or dents</span></p>
                                        <p class="inline-flex"><span>F</span> <span>Film/tinting on glass</span></p>
                                        <p class="inline-flex"><span>G</span> <span>Chip in glass</span></p>
                                        <p class="inline-flex"><span>H</span> <span>Hole</span></p>
                                        <p class="inline-flex"><span>K</span> <span>Flaw</span></p>
                                        <p class="inline-flex"><span>M</span> <span>Mark</span></p>
                                        <p class="inline-flex"><span>P</span> <span>Paint damage</span></p>
                                        <p class="inline-flex"><span>R</span> <span>Rust</span></p>
                                        <p class="inline-flex"><span>R</span> <span>Repaired crack in glass</span></p>
                                        <p class="inline-flex"><span>RX</span> <span>Repaired crack in glass that needs to be replaced</span>
                                        </p>
                                        <p class="inline-flex"><span>S</span> <span>Rust</span></p>
                                        <p class="inline-flex"><span>T</span> <span>Temporary spare tyre</span></p>
                                        <p class="inline-flex"><span>U</span> <span>Dents</span></p>
                                        <p class="inline-flex"><span>W</span> <span>Wave in paint (Often caused by repair work)</span>
                                        </p>
                                        <p class="inline-flex"><span>X</span> <span>Damage</span></p>
                                        <p class="inline-flex"><span>X</span> <span>Crack in glass</span></p>
                                        <p class="inline-flex"><span>XX</span> <span>Body-part replaced</span></p>
                                        <p class="inline-flex"><span>XXX</span> <span>Body-part replaced</span></p>
                                        <p class="inline-flex"><span>Y</span> <span>Crack or hole</span></p>
                                    </div>
                                    <div role="tabpanel" id="terms" class="tab-pane fade">
                                        <ol>
                                            <li>
                                                <h3>Claim Liability</h3>
                                                <ol>
                                                    <li>There are limitations on claims that can be made against SBL:
                                                    </li>
                                                    <li>SBL will not accept any mechanical claims for vehicles which
                                                        have travelled 100,000km or over and/or which have an auction
                                                        grade of 3.5 or below.
                                                    </li>
                                                    <li>SBL's claim liability on vehicles which have travelled between
                                                        80,000 and 100,000km and which have an auction grade above 3.5
                                                        is limited to the amount of the brokerage fee component of the
                                                        price of the vehicle.
                                                    </li>
                                                    <li>A ramp check system is compulsory for all vehicles purchased.
                                                        The purpose of the ramp check system is to eliminate whilst in
                                                        Japan any major mechanical or paint and panel costs. Any
                                                        vehicle arriving into NZ with excessive mechanical and/or paint
                                                        and panel costs needs to be brought to the attention of SBL
                                                        within 7 days of landing at your dealership. No work is to be
                                                        carried out on the vehicle at all without first consulting with
                                                        SBL either verbally or in writing.
                                                    </li>
                                                    <li>If the Purchaser makes any claim that a vehicle is defective or
                                                        damaged, SBL may, at its discretion, repair the damage or defect
                                                        or replace the vehicle or make a reasonable allowance on the
                                                        purchase of a replacement vehicle if:
                                                    </li>
                                                    <li>Without limiting SBL's ability to accept or decline claims, if
                                                        the Purchaser does not comply with the above requirements, it
                                                        will be deemed to have accepted . and SBL will not incur any
                                                        liability whatsoever to the Purchaser in relation to the
                                                        vehicle.
                                                    </li>
                                                </ol>
                                            </li>
                                        </ol>
                                        <a href="/files/SBLTerms.pdf" target="_blank">Please view our full terms and conditions here</a>
                                    </div>
                                    <div v-if="result.market_research && result.market_research.length" role="tabpanel" id="market-research-tab" class="tab-pane fade fade-in active show">
                                        <div id="market-research" class="table-responsive">
                                            <b-table
                                                class="bid-history table"
                                                :items="result.market_research"
                                                :fields="marketSearchFields"
                                            >
                                                <template v-slot:cell(end_price)="data">
                                                    <strong>{{numberWithCommas(data.item.end_price)}}</strong>
                                                </template>
                                            </b-table>
                                        </div>
                                    </div>
                                    <div v-if="result.co2_emissions && $userIsAdmin()" role="tabpanel" id="emissions" class="tab-pane fade">
                                        <Co2DataTable :emissions="{data: result.co2_emissions}" @row-click="selectedEmission = $event; showEmissionModal = true" />
                                    </div>
                                </div>
                            </div>
                            <a href="#!" v-if="$userIsAdmin() && loggedInUser.id === 513" @click.prevent="downloadLog" class="btn-link" style="margin-top: 15px;display: block;">Download Log</a>
                        </div>
                    </div>
                </div>
            </div>
            <EmissionModal 
                :show="showEmissionModal" 
                :emission="selectedEmission" 
                @close="showEmissionModal = false"
            />
            <no-claims-modal 
                :is-open="noClaimsModalOpen"
                :no-claims-reason="result.no_claims_accepted"
                @close="closeNoClaimsModal"
                @confirm="onConfirmNoClaimsBid"
            />
            <vehicle-recommendation-modal v-if="vehicleLoaded" :notifyMessage="recommendMessageSendEmail" :vehicle_id="result.api_id"
                                          :recommend="true"
                                          v-model="recommendModalOpen"></vehicle-recommendation-modal>
            <vehicle-recommendation-modal v-if="vehicleLoaded" :notifyMessage="notifyMessageSendEmail" :vehicle_id="result.api_id"
                                          v-model="emailModalOpen"></vehicle-recommendation-modal>
            <change-bid ref="changeBidModal" @changed="onBidChange"/>
            <b-modal ref="topBidModel" @ok="onTopBidOk" title="Top Bid" ok-title="Send">
                <p>
                    Hi<span
                    v-if="selectedBid && selectedBid.user && selectedBid.user.first_name"> {{
                        selectedBid.user.first_name
                    }}</span>,
                    to be top bidder within SBL your bid needs to be higher than <input type="text" ref="topBidText" v-model="topBidText"/>
                </p>
            </b-modal>
            <bid-message ref="bidMessage" @changed="onBidChange"/>
            <staff-message ref="staffMessage" @changed="onBidChange"/>
            <favourite-tag-modal
                v-if="$userCan('fav_list')"
                :vehicleId=result.api_id
                v-model="favListModalOpen"
                @changed="onTagChanged"
            ></favourite-tag-modal>
        </section>
    </div>
</template>
<script>

import {mapState, mapGetters, mapActions, mapMutations} from 'vuex'
import {
    getJapanDiff, downloadText,
    handleHttpError, numberWithCommas, objToUrl, getDate, getTime, getTimeAgo, getNZDateTime, getExceptionErrorMessage
} from '../util/common'
import axios from 'axios'
import moment from 'moment'
import {getYenFromLanded, getLandedCost, bidColourStyle} from '../util/bid_helper'
import changeBid from './VehicleSingle/ChangeBid.vue';
import bidMessage from './VehicleSingle/BidMessage.vue';
import VehicleImages from './Common/VehicleImages'
import Co2DataTable from './Co2Emissions/DataTable.vue'
import BootstrapValidation from '../mixins/bootstrap-validation';
import VehicleMessages from './Common/VehicleMessages'
import elementIUMessage from "element-ui/lib/message";
import staffMessage from "./VehicleSingle/StaffMessage";
import EmissionModal from './Co2Emissions/EmissionModal.vue'
import NoClaimsModal from "./NoClaimsModal.vue";

export default {
    props: [
        'vehicle_result',
        'is_favourite',
        'vid'
    ],
    components: {
        'change-bid': changeBid,
        'bid-message': bidMessage,
        'staff-message': staffMessage,
        VehicleImages,
        VehicleMessages,
        Co2DataTable,
        EmissionModal,
        'no-claims-modal': NoClaimsModal
    },
    async created() {
        let user_bid = this.userHasBid;
        if (user_bid) {
            this.estimatedLandedCost = numberWithCommas(user_bid.bid_price_landed);
            this.bidPriceProxy = numberWithCommas(user_bid.bid_price_jpy / 1000);
            this.bidPrice = user_bid.bid_price_jpy;
        }
        // load the cached vehicle data and quick as possible..
        setTimeout(async () => {
            await this.checkForCachedData();
        }, 1)
        if (this.vid) {
            // get vehicle data, make sure other requests are waiting for this one
            // to ensure it comes back as quick as possible
            await this.getVehicleData();
            await this.getNotifications(); //get notifications again since the current vehicles' will be marked as read
        } else {
            this.getAvtoImages();
            this.result = this.vehicle_result;
            this.isFavourite = this.is_favourite ? true : false
            this.focusBidField()
        }

        window.addEventListener('resize', this.onResize)

        this.is_mobile = window.innerWidth < 760;
        if (this.$route.query.state_key) {
            await this.checkStack(this.$route.query.state_key)
        }
        setTimeout(async () => {
            this.vehicleNextPrevCounter()
            await this.getNextPrevVehicleData();
            document.title = `SBL - ${this.result.lot} ${this.result.auction_house}`
        }, 50)
    },
    mixins: [BootstrapValidation],
    data() {
        return {
            is_mobile: false,
            noClaimsModalAccepted: false,
            noClaimsModalOpen: false,
            errors: [],
            change_bid_id: null,
            keepBidMsg: 'Keep bid',
            vehicleNextPrevCounterText: '',
            cancelBidMsg: 'Cancel bid',
            user: null,
            favTagModal: false,
            recommendModalOpen: false,
            emailModalOpen: false,
            result: false,
            copiedToStock: false,
            favListModalOpen: false,
            vehicleLoaded: false,
            loading: false,
            images: [],
            imagesType: ['sheet', 'front', 'back', 'interior'],
            estimatedLandedCost: '',
            bidPrice: 0,
            bidPriceProxy: null,
            bidNote: '',
            topBidText: '20,000',
            selectedMessage: null,
            selectedBid: null,
            bidSubmissionLoading: false,
            showEmissionModal: false,
            selectedEmission: null,
            showBids: [],
            fees: this.loggedInUser.pricing_rule || this.defaultPricing,
            isFavourite: false,
            bidResult: false,
            bidFavourites: {},
            translatedFields: {description: false, grade: false},
            bidTooltipDisabled: true,
            showBigImage: false,
            bigImageUrl: null,
            loadingSendNichiboImages: false,
            marketSearchFields: [
                { key: 'grade', label: 'Variant', sortable: true },
                { key: 'end_price', label: 'Sold Price (JPY)', sortable: true},
                { key: 'year', label: 'Year', sortable: true },
                { key: 'mileage', label: 'KM', sortable: true, formatter: value => numberWithCommas(value) },
                { key: 'engine_capacity', label: 'Engine', sortable: true },
                { key: 'color', label: 'Colour', sortable: true },
                { key: 'transmission', label: 'Trans', sortable: true },
                { key: 'condition', label: 'Grade', sortable: true },
            ],
            avtoImages: {
                extra: []
            },
            recommendMessageSendEmail: "I've hand-picked some vehicles that are going through auctions today that I hope you like. \n\n Look forward to seeing your bids soon. 🚗 😀 🥇"
        }
    },
    computed: {
        ...mapState({
            single_vehicle: state => state.auction_search.single_vehicle,
            single_next: state => state.auction_search.single_next,
            single_prev: state => state.auction_search.single_prev,
            user_currency_code: state => state.currency.user_currency_code,
            user_currency_sign: state => state.currency.user_currency_sign,
        }),
        ...mapGetters({
            currentNextPrev: 'auction_nextprev/current',
        }),
        showBidBox() {
            if (this.userHasBid || this.isSold() || !this.userHasPrivilege('can_bid')) {
                return false;
            }
            return true;
        },
    
        nextRetryTime() {
            const now = moment();
            const mins = now.minutes();
            const hours = now.hours();
            // if (hours > 16 || (hours > 15 && mins > 45)) {
            //     return '';
            // }
            //calculate how many minutes to the next 0,15,30,45 minute mark
            const diff = 15 - (mins % 15);
            return '| next in ' + diff + ' mins'
        },
        suggestedRange() {
            if (this.result.market_research && this.result.market_research.length){
                let total = 0;
                this.result.market_research.forEach(item => {
                    total += item.end_price
                })
                if (total) {
                    const avg = total / this.result.market_research.length;
                    //ranges, in thousands, rounded to the nearest 10 and +- 50k
                    const start = (Math.ceil(avg / 10000) * 10) - 50;
                    const end = (Math.ceil(avg / 10000) * 10) + 50;
                    return `${start}k - ${end}k`
                }
            }
            return '';
        },
        userHasBid() {
            let user_bid = false;
            if (this.result.userBids && this.result.userBids.length) {
                this.result.userBids.forEach(bid => {
                    if (bid.user_id === this.loggedInUser.id) {
                        user_bid = bid;
                    }
                });
            }
            return user_bid;
        },
        imagesCount: function () {
            let count = 0;
            this.imagesType.forEach(imageType => {
                if (this.result.images[imageType] && this.result.images[imageType]['large']) {
                    count++;
                }
            });

            if (this.result.images.extra) {
                count += this.result.images.extra.length;
            }

            return count;
        },
        avtoImagesCount: function () {
            let count = 0;
            this.imagesType.forEach(imageType => {
                if (this.avtoImages[imageType] && this.avtoImages[imageType]['large']) {
                    count++;
                }
            });

            if (this.avtoImages.extra) {
                count += this.avtoImages.extra.length;
            }

            return count;
        },
        notifyMessageSendEmail: function () {
            return `We have a ${this.result.year} ${this.result.make} ${this.result.model} that may work for you. Take a look at its details and place a bid.`;
        }
    },
    beforeDestroy() {
        // Unregister the event listener before destroying this Vue instance
        window.removeEventListener('resize', this.onResize)
    },
    methods: {
        ...mapActions({
            checkStack: 'auction_nextprev/checkStack',
            copyVehicleToStockAction: 'auction_search/copyVehicleToStock',
            addSingleVehicleToCurrent: 'auction_nextprev/addSingleVehicleToCurrent',
            getNotifications: 'notifications/getNotifications',
        }),
        ...mapActions('favourites', [
            'addFavourite',
            'removeFavourite'
        ]),
        ...mapMutations({
            setMarketResearch: 'market_research/setSearch',
            setSingleNext: 'auction_search/setSingleNext',
            setLogs: 'auction_search/setLogs',
            setSinglePrev: 'auction_search/setSinglePrev',
            setSingleVehicle: 'auction_search/setSingleVehicle',
        }),
        bidColourStyle,
        numberWithCommas,
        getDate,
        getTime,
        getTimeAgo,
        getNZDateTime,
        getJapanDiff,
        async copyVehicleToStock(vid) {
            try{
                if (!this.copiedToStock) {
                    this.copiedToStock = true
                    this.copyVehicleToStockAction(vid)
                    this.$message.success('Vehicle copied to stock.')
                }
            } catch (e) {
                this.$message.error('There was a problem copying vehicle to stock.')
                console.warn(e)
            }
        },
        vehicleNextPrevCounter(){
            let found = false;
            if (this.currentNextPrev) {
                let current = parseInt(this.vid);
                let i = this.currentNextPrev.ids.indexOf(current);
                if (i !== -1) {
                    let total = this.currentNextPrev.ids.length;
                    this.vehicleNextPrevCounterText = `${i + 1} of ${total}`
                    found = true
                }
            }
            if (!found) {
                this.vehicleNextPrevCounterText = '';
            }
        },

        showStatus(bid){
            if (bid.status_id === 5 && this.$userIsSuperAdmin()) {
                return true;
            }
            if (bid.status_id !== 5 && bid.status_id !== 1 && bid.status_id !== 6 && this.$userIsAdmin()) {
                return true;
            }
            return false;
        },
        getNextPrevId(next = true) {
            if (!this.currentNextPrev) {
                return;
            }
            let id = null;
            let current = parseInt(this.vid);
            let i = this.currentNextPrev.ids.indexOf(current);
            if (i !== -1) {
                if (next) {
                    if ((i+1) === this.currentNextPrev.ids.length) {
                        id = this.currentNextPrev.ids[0];
                    } else {
                        id = this.currentNextPrev.ids[i+1];
                    }
                } else {
                    if ((i-1) === -1) {
                        id = this.currentNextPrev.ids[this.currentNextPrev.ids.length - 1];
                    } else {
                        id = this.currentNextPrev.ids[i-1];
                    }
                }
            }
            const date  = new Date();
            const timestamp = Math.round(date.getTime()/1000 | 0);
            this.setLogs({
                key: next ? 'getNextId' : 'getPrevId',
                value: {i, current, id, timestamp}
            })
            return id;
        },
        next_id(){
            return this.getNextPrevId(true)
        },
        prev_id(){
            return this.getNextPrevId(false)
        },
        onResize(event) {
            this.is_mobile = event.target.innerWidth < 760;
        },
        handleNextPrevKeypress(e) {
            if (this.currentNextPrev) {
                let fancebox_open = $('.fancybox-is-open').length
                if (fancebox_open) {
                    return;
                }
                if (e.keyCode) {
                    const isLeftRight = e.keyCode === 37 //left
                        || e.keyCode === 39 //right
                    if (!$(e.target).is(':input')) {
                        if (isLeftRight) {
                            this.handleVehicleNextPrev(e.keyCode === 39);
                        }
                    } else if (($(e.target).is('#bidPrice') || $(e.target).is('#estimatedLandedCost')) && $(e.target).val() === '') {
                        if (isLeftRight) {
                            this.handleVehicleNextPrev(e.keyCode === 39);
                        }
                    }
                }
            }
        },
        openFavList() {
            if (this.$userCan('fav_list')) {
                this.favListModalOpen = true
            }
        },
        async checkForCachedData() {
            if (this.single_vehicle && this.single_vehicle.api_id === parseInt(this.vid)) {
                this.result = this.single_vehicle
                this.scrollToAnchor();
                this.focusBidField()
                this.loading = false
            }
        },
        async getNextPrevVehicleData() {
            if (this.next_id()) {
                if (!(this.single_next && this.single_next.api_id) || (this.single_next && this.single_next.api_id !== this.next_id())) {
                    let next_data = await this.requestVehicleData(this.next_id(), false)
                    if (next_data) {
                        this.setSingleNext(next_data.result)
                    }
                }
            }
            if (this.prev_id()) {
                if (!(this.single_prev && this.single_prev.api_id) || (this.single_prev && this.single_prev.api_id !== this.prev_id())) {
                    let prev_data = await this.requestVehicleData(this.prev_id(), false)
                    if (prev_data) {
                        this.setSinglePrev(prev_data.result)
                    }
                }
            }
        },
        async downloadLog(){
            const storage = {};
            for (let i = 0; i < window.sessionStorage.length; ++i) {
                const key = window.sessionStorage.key(i);
                const value = window.sessionStorage.getItem(key);
                storage[key] = value
            }
            downloadText('sbl-log.json', JSON.stringify(storage))
        },
        async handleVehicleNextPrev(next) {
            const processUrl = url => {
                if (this.$route.query.state_key) {
                    if (url.indexOf('?') === -1) {
                        url = url + '?state_key=' + this.$route.query.state_key
                    } else {
                        url = url + '&state_key=' + this.$route.query.state_key
                    }
                }
                return url
            }
            if (next) {
                if (this.single_next && this.single_next.api_id === this.next_id()) {
                    let url = processUrl(this.single_next.detail_url)
                    this.setSinglePrev(this.result)
                    this.setSingleVehicle(this.single_next);
                    await this.$router.push(url);
                } else {
                    let url = processUrl('/search/' + this.next_id())
                    await this.$router.push(url);
                }
            } else {
                if (this.single_prev && this.single_prev.api_id === this.prev_id()) {
                    let url = processUrl(this.single_prev.detail_url)
                    this.setSingleNext(this.result)
                    this.setSingleVehicle(this.single_prev);
                    await this.$router.push(url);
                } else {
                    let url = processUrl('/search/' + this.prev_id())
                    await this.$router.push(url);
                }
            }
        },
        onTagChanged(data) {
            if (data.removed) {
                if (data.tags_left === 0) {
                    this.isFavourite = false
                }
            } else {
                this.isFavourite = true
            }
        },
        focusBidField() {
            const focusField = () => {
                if (this.$refs.bidNzd && document.activeElement && document.activeElement.tagName !== 'INPUT') {
                    this.$refs.bidNzd.focus();
                }
            }
            focusField()
            setTimeout(() => {
                focusField()
            }, 1000)
        },
        addToBidNote(msg) {
            let div = document.createElement('div');
            div.innerHTML = msg;
            this.bidNote += div.textContent
        },
        removeCommas(number) {
            return parseFloat(number.replace(/,/g, ''));
        },
        bumpBidDisplay(number) {
            if (!number) {
                return '';
            }
            let k = number / 1000;
            return `Bump ${k}k`
        },
        showFavouriteTags() {
            this.favListModalOpen = true;
            this.$store.dispatch('favouriteTags/getTags', {});
        },
        onBidFavChange(bid) {
            if (this.bidFavourites[bid]) {
                this.$store.dispatch('bidFavourites/addFavourite', bid);
            } else {
                this.$store.dispatch('bidFavourites/removeFavourite', bid);
            }
        },
        selectMessage(msg) {
            if (this.selectedMessage && this.selectedMessage.id === msg.id) {
                this.selectedMessage = null
            } else {
                this.selectedMessage = msg
            }
        },
        messageClass(msg, bid) {
            let classes = []
            if (this.selectedMessage && this.selectedMessage.id === msg.id) {
                classes.push('selected')
            }
            if (msg.user_id === bid.user_id) {
                classes.push('bidder-message')
            } else if (msg.rep_only) {
                classes.push('staff-message')
            }
            return classes
        },
        async toggleFav() {
            if (this.isFavourite) {
                try {
                    this.isFavourite = false;
                    let res = await this.removeFavourite(this.result.api_id)
                    if (res !== true) {
                        this.isFavourite = true;
                    }
                } catch (e) {
                    this.isFavourite = true;
                }
            } else {
                try {
                    this.isFavourite = true;
                    let res = await this.addFavourite(this.result.api_id);
                    if (res !== true) {
                        this.isFavourite = false;
                    }
                } catch (e) {
                    this.isFavourite = false;
                }
            }
        },
        finalSoldPrice() {
            let return_val = false;
            if (this.result && this.result.sold_price) {
                return this.result.sold_price;
            }
            return false;
        },
        isSold() {
            let date = window.moment.tz(this.result.auction_date, 'Asia/Tokyo');
            let now = window.moment.tz(window.moment(), 'Asia/Tokyo');
            const time = date.format('HH:mm')
            if (time === '00:00') {
                date.add(1, 'day')
            }
            return now > date;
        },
        closeNoClaimsModal() {
            this.noClaimsModalOpen = false;
            this.errors = [];
        },
        async onConfirmNoClaimsBid() {
            this.noClaimsModalOpen = false;
            this.noClaimsModalAccepted = true;
            await this.onBidClick();
        },
        async onBidClick() {
            if (this.bidSubmissionLoading === false) {
                this.bidSubmissionLoading = true
                if (this.result.no_claims_accepted !== false && !this.noClaimsModalAccepted) {
                    this.noClaimsModalOpen = true;
                    this.bidSubmissionLoading = false;
                    this.errors = [];
                    return;
                }
                const landedCost = this.removeCommas(this.estimatedLandedCost)
                if (landedCost > 49100 && this.$userIsDealer()) {
                    this.$confirm('Please be aware that an immediate additional cash payment is required on confirmation of this purchase should your bid be successful', 'Cash Payment Required', {
                        confirmButtonText: 'Place Bid',
                        cancelButtonText: 'Cancel',
                        type: 'warning'
                    }).then(async () => {
                        await this.submitBid()
                        this.bidSubmissionLoading = false
                    }).catch(() => {
                        //they clicked cancel
                        this.bidSubmissionLoading = false
                    });
                } else {
                    await this.submitBid()
                    this.bidSubmissionLoading = false
                }
            }
        },
        async submitBid(){
            if (this.userHasBid) {
                this.changeBidButton();
            } else {
                await this.makeBid(this.result.api_id);
            }
        },
        async requestVehicleData(vid, markRead = true) {
            let data;
            let url = this.$laravelRoute('vehicle-detail', vid);
            let args = {}
            if (this.$route.query) {
                args = Object.assign(args, this.$route.query)
            }
            args.mark_read = markRead ? 1 : 0
            url += '?' + objToUrl(args);
            try {
                let result = await this.axios.get(url);
                if (result.data) {
                    data = result.data;
                }
            } catch (e) {
                console.warn(e);
            }
            return data;
        },
        async getVehicleData(vid, args) {
            this.loading = true
            try {
                let data = await this.requestVehicleData(this.vid)
                this.loading = false
                if (data) {
                    this.result = data.result;
                    this.vehicleLoaded = true;
                    this.setSingleVehicle(this.result);
                    this.isFavourite = data.is_favourite ? true : false;
                    let bid_favs = {};
                    if (this.result.userBids && this.result.userBids.length) {
                        this.result.userBids.forEach(bid => {
                            if (bid.favourites_count > 0) {
                                bid_favs[bid.id] = true
                            } else {
                                bid_favs[bid.id] = false
                            }
                        })
                    }
                    this.translateData()
                    this.bidFavourites = bid_favs
                    this.scrollToAnchor();
                    this.focusBidField()
                }
            } catch (e) {
                console.warn(e);
                this.loading = false;
            }
            // this.getAvtoImages();
        },
        async translateData() {
            let fields = ['grade', 'description']
            if (this.result) {
                let to_translate = [];
                let fields_map = {};
                let i = 0;
                const kanjiTest = new RegExp(/[\u3000-\u303f\u3040-\u309f\u30a0-\u30ff\uff00-\uff9f\u4e00-\u9faf\u3400-\u4dbf]/);
                fields.forEach(v => {
                    if (this.result[v]) {
                        let div = document.createElement('div');
                        div.innerHTML = this.result[v];
                        const passed = kanjiTest.test(div.textContent);
                        console.log(v, passed, div.textContent);
                        if (passed) {
                            to_translate.push(div.textContent)
                            fields_map[v] = i
                            i++
                        }
                    }
                })
                if (to_translate.length) {
                    try{
                        let query = objToUrl({text: to_translate, source: 'ja'})
                        let res = await this.axios.get('/translate-batch?' + query)
                        if (res && res.data && res.data.translations && res.data.translations.length === to_translate.length) {
                            fields.forEach((v, i) => {
                                if (fields_map.hasOwnProperty(v) && res.data.translations[fields_map[v]] !== to_translate[fields_map[v]]) {
                                    this.translatedFields[v] = res.data.translations[fields_map[v]]
                                }
                            })
                        }
                    } catch (e) {
                        console.warn('translate err', e)
                    }
                }
            }
        },
        async makeBid(vehicle_id) {
            this.bidTooltipDisabled = true;
            if (this.userHasBid) {
                await this.$confirm('You have already placed a bid.', 'Cannot place bid', {
                    confirmButtonText: 'Okay',
                    showCancelButton: false,
                    type: 'error'
                })
            } else if (vehicle_id && this.bidPrice) {
                try {
                    let no_claims_accepted = this.result.no_claims_accepted;
                    if (no_claims_accepted === false) {  
                        no_claims_accepted = null;
                    }
                    this.bidResult = false;
                    let result = await this.$store.dispatch('userBids/storeBid', {
                        api_id: vehicle_id,
                        landed_price: this.removeCommas(this.estimatedLandedCost),
                        note: this.bidNote,
                        no_claims_accepted: no_claims_accepted,
                        no_claims_confirm: this.noClaimsModalAccepted,
                    });
                    if (result && result.data) {
                        if (!this.result.userBids) {
                            this.result.userBids = [];
                        }
                        this.result.userBids.push(result.data);
                        this.calculatedBidPrice = '';
                        this.estimatedLandedCost = '';
                        if (result.data.status_id === 2) {
                            this.$message.error(result.message)
                        }
                    }

                    if (result && result.message) {
                        this.bidResult = result.message;
                        this.bidTooltipDisabled = false;
                        this.$refs.bidResultTooltip.$emit('open');
                        setTimeout(() => {
                            this.bidTooltipDisabled = true;
                        }, 5000);
                        this.getVehicleData();
                    }
                } catch (e) {
                    console.warn('error', e);
                    let message = getExceptionErrorMessage(e);
                    if (message) {
                        await this.$confirm(message, 'Cannot place bid', {
                            confirmButtonText: 'Okay',
                            showCancelButton: false,
                            type: 'error'
                        })
                    }
                }
            }
        },
        toggleFavourite() {
            if (this.isFavourite) {
                this.$store.dispatch('favourites/addFavourite', this.result.api_id);
            } else {
                this.$store.dispatch('favourites/removeFavourite', this.result.api_id);
            }
        },
        async addBidMessage(bid_id, message, rep_only) {
            let div = document.createElement('div');
            div.innerHTML = message;
            message = div.textContent
            try {
                let result = await this.$store.dispatch('userBids/addBidMessage', {bid_id, rep_only, message});
                if (result.bid_message) {
                    this.updateViewMessages(bid_id, result.bid_message, result.bid);
                }
            } catch (e) {
                handleHttpError(e);
            }
        },
        async deleteMessage(bid, message) {
            try {
                const result = await this.$store.dispatch('userBids/deleteBidMessage', {
                    bid_id: bid.id,
                    message: message
                });
                this.deleteViewMessage(bid.id, message.id);
            } catch (e) {
                handleHttpError(e);
            }
        },
        async cancelBid(bid_id) {
            try {
                const result = await this.$store.dispatch('userBids/cancelBid', {bid_id});
                if (result.message) {
                    this.updateViewMessages(bid_id, result.message, result.bid);
                    await this.getVehicleData();
                }
            } catch (e) {
                handleHttpError(e);
            }
        },
        openMessageModal(bid) {
            let msg = ''
            if (this.selectedMessage)
                msg = this.selectedMessage.message.replace(/\[.*\]/, '')
            this.$refs.bidMessage.openModal(bid, null, msg);
        },
        openStaffMessageModal(bid) {
            let msg = ''
            if (this.selectedMessage) {
                msg = this.selectedMessage.message.replace(/\[.*\]/, '')
            }
            this.$refs.bidMessage.openModal(bid, null, msg, true, true);
        },
        changeBidButton() {
            let bid = this.userHasBid;
            this.openChangeBidModal(bid);
        },
        openChangeBidModal(bid) {
            if (this.$canChangeBid(bid, this.result)) {
                this.$refs.changeBidModal.openModal(bid);
            } else {
                this.$message.error("Bids can't be changed this close to the auction time.")
            }
        },
        openTopBidModal(bid) {
            this.selectedBid = bid
            this.$refs.topBidModel.show()
            this.$nextTick(() => {
                this.$refs.topBidText.focus()
            })
        },
        async onClickSendNichiboImages(bid) {
            try {
                this.loadingSendNichiboImages = true
                await this.$store.dispatch('userBids/sendNichiboImages', bid.id);
                this.$message.success("Message sent and image access enabled.")
                bid.can_view_nichibo_images = true
                this.loadingSendNichiboImages = false
            } catch (e) {
                this.loadingSendNichiboImages = false
                this.$message.error("There was an issue sending the message.")
            }
        },
        async onTopBidOk() {
            let message = `Hi`;
            if (this.selectedBid && this.selectedBid.user && this.selectedBid.user.first_name) {
                message += ' ' + this.selectedBid.user.first_name
            }
            message += `, to be top bidder within SBL your bid needs to be higher than ${this.topBidText}`
            let bid_id = this.selectedBid.id;
            let result = await this.$store.dispatch('userBids/addBidMessage', {
                bid_id, message,
                rep_only: false,
                with_email: true
            });
            this.updateViewMessages(bid_id, result.bid_message, result.bid);
        },
        onBidChange(bid_id, message, result) {
            // this.updateViewMessages(bid_id, message, result.bid);
            this.getVehicleData();
        },
        updateViewMessages(bid_id, message, bid = false) {
            this.result.userBids.forEach((userBid, i) => {
                if (userBid.id === bid_id) {
                    if (bid) {
                        userBid.bid_price_jpy = bid.bid_price_jpy;
                        userBid.bid_price_landed = bid.bid_price_landed;
                    }
                    if (Array.isArray(message)) {
                        message.forEach((msg) => {
                            userBid.messages.push(msg);
                        })
                    } else {
                        userBid.messages.push(message);
                    }
                }
            });
        },
        deleteViewMessage(bid_id, message_id) {
            this.result.userBids.forEach((userBid, i) => {
                if (userBid.id === bid_id) {
                    userBid.messages = userBid.messages.filter(message => message.id !== message_id);
                }
            });
        },
        onLandedCostInput() {
            try {

                let cost = this.removeCommas(this.estimatedLandedCost);
                let yen = getYenFromLanded(cost, this.fees, this.user_currency_code);
                if (yen > 0) {
                    this.bidPriceProxy = numberWithCommas(yen / 1000);
                    this.bidPrice = yen;
                } else {
                    this.bidPriceProxy = '';
                    this.bidPrice = 0;
                }
            } catch (e) {
                this.onFeeError(e)
            }
        },
        onBidPriceInput() {
            if (this.bidPriceProxy === '') {
                this.estimatedLandedCost = ''
            } else {
                this.bidPrice = this.removeCommas(this.bidPriceProxy) * 1000;
                try {
                    this.estimatedLandedCost = numberWithCommas(getLandedCost(this.bidPrice, this.fees, this.user_currency_code));
                } catch (e) {
                    this.onFeeError(e)
                }
            }
        },
        onFeeError(e) {
            this.$message.error('There was a problem calculating your bid. Please refresh the page and try again.')
            console.warn(e)
            this.bidPriceProxy = '';
            this.bidPrice = 0;
            this.estimatedLandedCost = ''
        },
        getAvtoImages() {
            let requestData = {
                params: {
                    lot: this.result.lot,
                    auction_date: window.moment(this.result.auction_date.date).format(this.defaultMomentDateFormat()),
                    auction_house: this.result.auction_house,
                }
            };
            let route = this.$laravelRoute('get-avto-images', [], true);

            axios.get(route, requestData).then(response => {
                if (response && response.data) {
                    this.avtoImages = response.data;
                }
            })
        },
        scrollToAnchor() {
            setTimeout(() => {
                const singlePage = document.getElementById('single-vehicle-page')
                if (singlePage) {
                    singlePage.scrollIntoView();
                }
            }, 500);
        },
        displayBigImage(url) {
            this.showBigImage = true;
            this.bigImageUrl = url;
        },
        hideBigImage() {
            this.showBigImage = false;
        },
        getFile(file) {
            window.open('storage/files/' + file, "_blank");
        }
    }
}
</script>



<style scoped lang="scss">

@import "./resources/sass/mixins";
@import "./resources/sass/variables";

</style>




// WEBPACK FOOTER //
// resources/js/components/SingleVehicle.vue